var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0402 37.9548C0.270863 39.2882 1.23314 40.9544 2.77251 40.9544H45.2271C46.7665 40.9544 47.7287 39.2882 46.9594 37.9548L25.7321 1.16616C24.9624 -0.167773 23.0372 -0.167771 22.2675 1.16616L1.0402 37.9548ZM26.2429 33.198C26.2429 33.7503 25.7952 34.198 25.2429 34.198H22.7538C22.2015 34.198 21.7538 33.7503 21.7538 33.198V30.6937C21.7538 30.1415 22.2015 29.6937 22.7538 29.6937H25.2429C25.7952 29.6937 26.2429 30.1415 26.2429 30.6937V33.198ZM25.2429 27.4417C25.7952 27.4417 26.2429 26.9939 26.2429 26.4417V17.181C26.2429 16.6287 25.7952 16.181 25.2429 16.181H22.7538C22.2015 16.181 21.7538 16.6287 21.7538 17.181V26.4417C21.7538 26.9939 22.2015 27.4417 22.7538 27.4417H25.2429Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.36d883b66301686876e99ba75e080b9f.svg";
export { ForwardRef as ReactComponent };